"use client";

import React, { useState } from "react";
import { MapPin } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
interface PincodeInputProps {
  onCheck: (pincode: string) => void;
  isLoading: boolean;
}
export const PincodeInput = ({ onCheck, isLoading }: PincodeInputProps) => {
  const [pincode, setPincode] = useState<string>("");
  const [error, setError] = useState<string>("");
  const handlePincodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 6) {
      setPincode(value);
      setError("");
    }
  };
  const handleCheck = () => {
    if (!pincode || pincode.length !== 6) {
      setError("Please enter a valid 6-digit pincode");
      return;
    }
    setError("");
    onCheck(pincode);
  };
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleCheck();
    }
  };
  return (
    <div className="space-y-3">
      <div className="flex gap-2">
        <div className="flex-1 relative">
          <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <Input
            type="text"
            placeholder="Enter pincode"
            value={pincode}
            onChange={handlePincodeChange}
            onKeyPress={handleKeyPress}
            className="pl-10 h-12 border-gray-300 focus:border-primary-blue focus:ring-1 focus:ring-primary-blue"
            maxLength={6}
          />
        </div>
        <Button
          onClick={handleCheck}
          disabled={isLoading || pincode.length !== 6}
          className="h-12 px-6"
        >
          {isLoading ? (
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            "CHECK"
          )}
        </Button>
      </div>
      
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};